import { render, staticRenderFns } from "./SpeakersTable.vue?vue&type=template&id=44adec88"
import script from "./SpeakersTable.vue?vue&type=script&lang=js"
export * from "./SpeakersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports